{
  "title": "Goodberry",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a sprig of mistletoe)",
  "duration": "Instantaneous",
  "description": [
    "Up to ten berries appear in your hand and are infused with magic for the duration. A creature can use its action to eat one berry. Eating a berry restores 1 hit point, and the berry provides enough nourishment to sustain a creature for one day.",
    "The berries lose their potency if they have not been consumed within 24 hours of the casting of this spell."
  ],
  "spellLists": ["druid", "ranger"]
}
